"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clampCropToAspect = clampCropToAspect;
exports.cropAspectRatios = void 0;
exports.getCropAspect = getCropAspect;
exports.getCropBox = getCropBox;
exports.getCropBoxStyle = getCropBoxStyle;
exports.getCropFromResizeHandle = getCropFromResizeHandle;
exports.getCroppedPreviewFrameStyle = getCroppedPreviewFrameStyle;
exports.getCroppedPreviewImageStyle = getCroppedPreviewImageStyle;
const cropAspectRatios = exports.cropAspectRatios = [{
  id: '3.5x5',
  label: '3.5 x 5 inches',
  value: 3.5 / 5
}, {
  id: '4x6',
  label: '4 x 6 inches',
  value: 4 / 6
}, {
  id: '4.5x6',
  label: '4.5 x 6 inches',
  value: 4.5 / 6
}, {
  id: '5x5',
  label: '5 x 5 inches',
  value: 1
}, {
  id: '5x7',
  label: '5 x 7 inches',
  value: 5 / 7
}, {
  id: '5x7.5',
  label: '5 x 7.5 inches',
  value: 5 / 7.5
}, {
  id: '6x6',
  label: '6 x 6 inches',
  value: 1
}, {
  id: '6x8',
  label: '6 x 8 inches',
  value: 6 / 8
}, {
  id: '6x9',
  label: '6 x 9 inches',
  value: 6 / 9
}, {
  id: '8x8',
  label: '8 x 8 inches',
  value: 1
}, {
  id: '8x10',
  label: '8 x 10 inches',
  value: 8 / 10
}, {
  id: '8x12',
  label: '8 x 12 inches',
  value: 8 / 12
}];
function getCropAspect(crop) {
  const aspect = cropAspectRatios.find(ratio => ratio.id === crop?.aspect)?.value || 1;
  return crop?.orientation === 'landscape' ? 1 / aspect : aspect;
}
function getCropBox(crop, frameAspect = 1) {
  const aspect = getCropAspect(crop);
  const layoutAspect = aspect / frameAspect;
  const size = clampPercent(crop?.size ?? 100, 24, 100);
  let width = size;
  let height = size;
  if (layoutAspect >= 1) {
    height = width / layoutAspect;
  } else {
    width = height * layoutAspect;
  }
  const x = clampPercent(crop?.x ?? 50, width / 2, 100 - width / 2);
  const y = clampPercent(crop?.y ?? 50, height / 2, 100 - height / 2);
  return {
    aspect,
    layoutAspect,
    height,
    size,
    width,
    x,
    y,
    left: x - width / 2,
    top: y - height / 2
  };
}
function clampCropToAspect(crop, frameAspect = 1) {
  const box = getCropBox(crop, frameAspect);
  return {
    aspect: crop?.aspect || '1:1',
    orientation: crop?.orientation === 'landscape' ? 'landscape' : 'portrait',
    size: box.size,
    x: box.x,
    y: box.y
  };
}
function getCropFromResizeHandle(crop, handle, pointerX, pointerY, frameAspect = 1) {
  const box = getCropBox(crop, frameAspect);
  const movesRight = handle.includes('right');
  const movesBottom = handle.includes('bottom');
  const anchorX = movesRight ? box.left : box.left + box.width;
  const anchorY = movesBottom ? box.top : box.top + box.height;
  const dragX = clampPercent(pointerX, 0, 100);
  const dragY = clampPercent(pointerY, 0, 100);
  const candidateWidth = Math.max(0, movesRight ? dragX - anchorX : anchorX - dragX);
  const candidateHeight = Math.max(0, movesBottom ? dragY - anchorY : anchorY - dragY);
  const maxWidth = movesRight ? 100 - anchorX : anchorX;
  const maxHeight = movesBottom ? 100 - anchorY : anchorY;
  const maxSize = box.layoutAspect >= 1 ? Math.min(100, maxWidth, maxHeight * box.layoutAspect) : Math.min(100, maxHeight, maxWidth / box.layoutAspect);
  const minSize = Math.min(24, maxSize);
  const size = clampPercent(box.layoutAspect >= 1 ? Math.max(candidateWidth, candidateHeight * box.layoutAspect) : Math.max(candidateHeight, candidateWidth / box.layoutAspect), minSize, maxSize);
  const width = box.layoutAspect >= 1 ? size : size * box.layoutAspect;
  const height = box.layoutAspect >= 1 ? size / box.layoutAspect : size;
  const left = movesRight ? anchorX : anchorX - width;
  const top = movesBottom ? anchorY : anchorY - height;
  return clampCropToAspect({
    aspect: crop?.aspect || '1:1',
    orientation: crop?.orientation,
    size,
    x: left + width / 2,
    y: top + height / 2
  }, frameAspect);
}
function getCropBoxStyle(crop, frameAspect = 1) {
  const box = getCropBox(crop, frameAspect);
  return {
    width: `${box.width}%`,
    height: `${box.height}%`,
    left: `${box.left}%`,
    top: `${box.top}%`
  };
}
function getCroppedPreviewFrameStyle(crop, frameAspect = 1) {
  const box = getCropBox(crop, frameAspect);
  return {
    aspectRatio: box.aspect
  };
}
function getCroppedPreviewImageStyle(crop, style = {}, frameAspect = 1) {
  const box = getCropBox(crop, frameAspect);
  return {
    ...style,
    height: `${10000 / box.height}%`,
    left: `${-box.left / box.width * 100}%`,
    position: 'absolute',
    top: `${-box.top / box.height * 100}%`,
    width: `${10000 / box.width}%`
  };
}
function clampPercent(value, min, max) {
  return Math.max(min, Math.min(max, Number(value)));
}